<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col>
        <v-card>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="customerVariableItems"
              :footer-props="datatable_footer"
              no-data-text="Нет данных для отображения"
            >
              <template v-slot:top>
                <v-card flat>
                  <v-card-text>
                    <v-row dense>
                      <v-col
                        cols="12"
                        md="3"
                      >
                        <autocomplete
                          ref="autocomplete"

                          :get-result-value="getResultValue"
                          :search="search"
                          @submit="onSubmit"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        sm="3"
                        md="2"
                      >
                        <v-btn
                          color="primary"
                          outlined
                          @click="onOpenFilter"
                        >
                          <v-icon class="ml-3">
                            mdi-filter-variant
                          </v-icon>
                          <span class="mx-3">ФИЛЬТРЫ</span>
                        </v-btn>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="5"
                        md="5"
                        class="d-flex justify-sm-end flex-wrap"
                      >
                        <v-tooltip
                          bottom
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              class="ma-0"
                              color="primary"
                              v-bind="attrs"
                              @click="createItem"
                              v-on="on"
                            >
                              <v-icon class="ml-3">
                                mdi-plus
                              </v-icon>
                              <span class="mx-3">Добавить</span>
                            </v-btn>
                          </template>
                          <span>Создать новый атрибут</span>
                        </v-tooltip>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="4"
                        md="2"
                        class="d-flex justify-sm-end"
                      >
                        <v-btn
                          color="secondary"
                          outlined
                          class="ma-0"
                          @click="downloadReport"
                        >
                          <v-icon class="ml-3">
                            mdi-download
                          </v-icon>
                          <span class="mx-3">Выгрузить</span>
                        </v-btn>
                        <v-icon
                          medium
                          class="icon-table"
                          @click="onOpenHeader"
                        >
                          mdi-table-cog
                        </v-icon>
                      </v-col>
                    </v-row>
                    <v-row>
                      <div>
                        <v-chip
                          v-for="(filter, index) in filterStuff"
                          v-show="filter.fieldValue !== '' && filter.fieldValue !== undefined"
                          :key="'i' + index"
                          close
                          @click:close="onClearFilter(filter)"
                        >
                          <span>{{ filter.fieldName }}: {{ filter.fieldValue }}</span>
                        </v-chip>
                      </div>
                    </v-row>
                  </v-card-text>
                </v-card>
              </template>
              <template v-slot:item.actions="{ item }">
                <task-menu
                  @delete="deleteItem(item)"
                  @edit="editItem(item)"
                />
              </template>
              <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
                {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <filter-dialog
          :dialog-visible="filterDialogVisible"
          :filter-label="filterLabel"
          :filter-stuff="filterStuff"
          @close="onCloseFilter"
          @filter="onSetFilter"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <header-dialog
          :dialog-visible="headerDialogVisible"
          :dialog-headers="dialogHeaders"
          @close="onCloseHeader"
          @header="onSetHeader"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        class="mt-5"
        cols="12"
      >
        <item-list
          :dialog-visible="dialogVisible"
          :headers="attributeItemsHeader"
          :item-list="attributeItemsList"
          item-key="attributeId"
          @close="closeDialog"
          @getItem="addAttributeItem"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TaskMenu from "@/views/loyalty/shared/components/task-menu/TaskMenu"
import WebApi from "@/views/loyalty/shared/modules/web_api"
import { CustomerVariableService } from "@/views/loyalty/shared/services/customer_variable_service"
import ItemList from "@/views/loyalty/shared/components/item-list/ItemList"
import Autocomplete from "@/views/loyalty/shared/components/search-autocomplete/Autocomplete"
import { FilterItem, FilterStuff } from "@/views/loyalty/shared/classes/filter_stuff"
import FilterDialog from "@/views/loyalty/shared/components/filter/FilterDialog"
import HeaderDialog from "@/views/loyalty/shared/components/header/HeaderDialog"
import { HeaderService } from "@/views/loyalty/shared/services/header_service"
import {
  downloadCsvFile,
  getCsvFile,
  getObjectsForSearching,
  getSearchedObjects
} from "@/views/loyalty/shared/modules/utilities"
import { TransactionModel } from "@/views/loyalty/models/transaction.model"

export default {
  name: "CustomerVariableList",
  components: { Autocomplete, ItemList, FilterDialog, HeaderDialog, TaskMenu },
  data: () => ({
    attributeItemsHeader: [
      // {
      //   text: "ID",
      //   value: "attributeId"
      // },
      {
        text: "Наименование",
        value: "name"
      },
      {
        text: "Выбрать",
        value: "actions"
      }
    ],
    attributeItemsList: [],
    datatable_footer: {
      itemsPerPageText: 'Показывать по',
      pageText: 'из',
      itemsPerPageAllText: 'Все',
    },
    dialogHeaders: [],
    dialogVisible: false,
    filterDialogVisible: false,
    filterLabel: 'cvariable.filter',
    filterStuff: [],
    headerDialogVisible: false,
    headers: [],
    headerService: null,
    customerVariableItems: [],
    webApi: null,
  }),
  beforeMount () {
    const that = this
    this.headers = CustomerVariableService.getHeaders()
    this.headerService = new HeaderService(this.headers)
    localStorage.removeItem(this.filterLabel)
    this.webApi = new WebApi(this.$store).readError("Не удалось прочитать данные")
        .createSuccess("Данные успешно созданы")
        .createError("Произошла ошибка при создании данных")
    this.webApi.get(`${process.env.VUE_APP_LOYALTY_URL}api/header/cvariable/${this.$store.state.client ? this.$store.state.client.id : "0"}`)
        .then(function (data) {
          console.log('header data', data)
          that.dialogHeaders = that.headerService.get_header(data)
          console.log('that.dialogHeaders', that.dialogHeaders)
          that.headers = that.headerService.get_header_list(data)
          console.log('that.headers', that.headers)
        })
    this.fillFilterStuff()
  },
  async mounted () {
    this.customerVariableItems = await this.getItems()
  },
  methods: {
    // item is Array
    addAttributeItem (item) {
      console.log('item', item)
      console.log('current_client', this.$store.state.user.current_client)
      const customerVariableObj = new CustomerVariableService().addAttributes(item).addCustomer(this.$store.state.user.current_client)
      console.log('customerVariableObj', customerVariableObj)
      if (!this.customerVariableItems.some(s => s.attributeId === item.attributeId)) {
        this.webApi.post(`${process.env.VUE_APP_LOYALTY_URL}api/customer_variable/`, customerVariableObj.item)
        .then(data => {
          console.log('post', data)
          this.customerVariableItems.push(data)
          console.log('customerVariableItems', this.customerVariableItems)
        })
      }
    },
    closeDialog () {
      this.dialogVisible = false
    },
    createItem () {
      // this.$router.push({ name: "CustomerVariableEditLink", params: { customerVariableId: '0' } })
      this.showDialog()
    },
    deleteItem (item) {
      const that = this
      this.webApi
          .delete(`${process.env.VUE_APP_LOYALTY_URL}api/customer_variable/` + item.customerVariableId)
          .then(function (data) {
            console.log(data)
            if (data) {
              that.getItems()
            }
          })
    },
    downloadReport () {
      console.log("customerVariableItems", this.customerVariableItems)
      let csv = "Название;Описание;Порядок следования;Удалён;\n"
      csv += getCsvFile(this.customerVariableItems.map(item => { return Reflect.construct(CustomerVariableService, [item]) }))
      console.log("csv", csv)
      downloadCsvFile("AttributeCustomerReport", csv)
    },
    editItem (item) {
      this.$router.push({ name: "CustomerVariableEditLink", params: { cvariableId: item.customerVariableId } })
    },
    fillFilterStuff () {
      this.filterStuff = new FilterStuff()
      this.filterStuff.add(new FilterItem().fieldName("Название").fieldValue("").fieldType("text").value)
      this.filterStuff.add(new FilterItem().fieldName("Описание").fieldValue("").fieldType("text").value)
      this.filterStuff.add(new FilterItem().fieldName("Порядок следования").fieldValue("").fieldType("text").value)
      this.filterStuff.add(new FilterItem().fieldName("Удалён").fieldValue("").fieldType("select").fieldValues([{ text: 'Нет', value: 'Нет' }, { text: 'Да', value: 'Да' }]).value)
      this.filterStuff = this.filterStuff.items
      console.log('filterStuff', this.filterStuff)
      return this.filterStuff
    },
    getItems () {
      return this.webApi.get(`${process.env.VUE_APP_LOYALTY_URL}api/customer_variables/${this.$store.state.user.current_client}`).then(data => {
        console.log('customervariables', data)
        return data.map(item => (Reflect.construct(CustomerVariableService, [item])).item)
      })
    },
    getResultValue (result) {
      return result.searched
    },
    onClearFilter (filter) {
      console.log('filter', filter)
      const attrFilter = JSON.parse(localStorage.getItem(this.filterLabel))
      const newFilter = attrFilter.filter(f => { if (f.fieldValue === filter.fieldValue) { f.fieldValue = ""; return true } else { return true } })
      console.log('newFilter', newFilter)
      localStorage.setItem(this.filterLabel, JSON.stringify(newFilter))
      this.onSetFilter()
    },
    onCloseFilter () {
      const filterStuff = JSON.parse(localStorage.getItem(this.filterLabel))
      console.log('const filterStuff', filterStuff)
      this.filterStuff = filterStuff || this.fillFilterStuff()
      console.log('onCloseFilter this.filterStuff', this.filterStuff)
      this.filterDialogVisible = false
    },
    onCloseHeader () {
      this.headerDialogVisible = false
    },
    onOpenFilter () {
      this.filterDialogVisible = true
    },
    async onSetFilter () {
      this.filterStuff = JSON.parse(localStorage.getItem(this.filterLabel)) || ''
      // console.log('attrFilter', attrFilter)
      this.filterDialogVisible = false
      // this.filterStuff = new FilterStuff(attrFilter).items
      console.log('this.filterStuff', this.filterStuff)
      if (this.filterStuff.length > 0) {
        this.customerVariableItems = await this.getItems().then(data => {
          return data.filter(f =>
              (f.nickname.includes(this.filterStuff[0].fieldValue) || this.filterStuff[0].fieldValue.length === 0) &&
              (f.hint.includes(this.filterStuff[1].fieldValue) || this.filterStuff[1].fieldValue.length === 0) &&
              (f.order.toString().includes(this.filterStuff[2].fieldValue) || this.filterStuff[2].fieldValue.length === 0) &&
              (f.deletedHuman === this.filterStuff[3].fieldValue || this.filterStuff[3].fieldValue.length === 0))
        })
      } else {
        this.customerVariableItems = await this.getItems()
      }
      console.log('this.customerVariableItems', this.customerVariableItems)
      // })
    },
    onOpenHeader () {
      const that = this
      this.headerDialogVisible = true
      this.webApi.get(`${process.env.VUE_APP_LOYALTY_URL}api/header/cvariable/${this.$store.state.client ? this.$store.state.client.id : "0"}`)
          .then(function (data) {
            console.log('header data', data)
            that.dialogHeaders = that.headerService.get_header(data)
          })
    },
    onSetHeader (value) {
      const that = this
      console.log('onSetHeader', value)
      this.dialogHeaders = value
      this.headerDialogVisible = false
      const headers = this.headerService.set_header("cvariable", this.$store.state.client ? this.$store.state.client.id : "0", value)
      console.log('headers', headers)
      this.webApi.post(`${process.env.VUE_APP_LOYALTY_URL}api/header/`, headers)
      that.headers = that.headerService.get_header_list(headers)
    },
    onSubmit (result) {
      const searching = result.searched ? result.searched : result
      if (searching.length !== 0) {
        this.customerVariableItems = getObjectsForSearching(this.customerVariableItems, searching)
      } else {
        this.onSetFilter()
      }
    },
    search (input) {
      console.log('search', input)
      if (input.length < 1) { return [] }
      const arr = getSearchedObjects(this.customerVariableItems, input)
      console.log('arr', arr)
      return arr
    },
    showDialog () {
      this.webApi.get(`${process.env.VUE_APP_LOYALTY_URL}api/attributes/`).then(data => {
        console.log('data', data)
        this.attributeItemsList = data.map(item => item)
      })
      this.dialogVisible = true
    },
  }
}
</script>

<style scoped>

</style>
